module.exports = __webpack_public_path__ + "static/media/registry.68a12fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/registry.png
// module id = 1511
// module chunks = 43